import { Box, Divider, Image, Stack, Text } from '@mantine/core';

import { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Link from '../../components/Link';
import paths from '../paths';

function Section({ tKey, t }: { tKey: string; t: (key: string) => string }) {
return (
<Stack gap="xs">
<Text fz="1.5rem" ff="var(--ff-title)">
{t(`legal.privacyPolicy.${tKey}.title`)}
</Text>
<Text fz="sm">
{t(`legal.privacyPolicy.${tKey}.content`)}
</Text>
</Stack>
);
}

function SubSection({ tKey, t }: { tKey: string; t: (key: string) => string }) {
return (
<Stack gap="xs" pl="md">
<Text fz="1.25rem" ff="var(--ff-title)">
{t(`legal.privacyPolicy.${tKey}.title`)}
</Text>
<Text fz="sm">
{t(`legal.privacyPolicy.${tKey}.content`)}
</Text>
</Stack>
);
}

export default function PrivacyPolicy() {
const { t } = useTranslation();

return (
<Fragment>
<Helmet>
<title>
{t('legal.privacyPolicy.pageTitle')}
</title>
</Helmet>

<Stack w="100%">
<Stack my="xl">
<Stack gap="md">
<Stack gap="md">
<Text fz="2rem" ff="var(--ff-title)" c="teal.6">
{t('legal.privacyPolicy.title')}
</Text>
<Text fz="sm" fw="300">
{t('legal.privacyPolicy.lastUpdated')}
</Text>
</Stack>

<Divider />

{/* Intro */}
<Text fz="sm">
{t('legal.privacyPolicy.intro')}
</Text>

{/* 1. Information We Collect */}
<Stack gap="xs">
<Text fz="1.5rem" ff="var(--ff-title)">
{t('legal.privacyPolicy.informationWeCollect.title')}
</Text>
</Stack>
<SubSection tKey="informationWeCollect.providedByYou" t={t} />
<SubSection tKey="informationWeCollect.automaticallyCollected" t={t} />
<SubSection tKey="informationWeCollect.notCollected" t={t} />

{/* 2-8: Simple sections */}
<Section tKey="howWeUse" t={t} />
<Section tKey="legalBasisGDPR" t={t} />
<Section tKey="legalBasisKVKK" t={t} />
<Section tKey="howWeShare" t={t} />
<Section tKey="dataRetention" t={t} />
<Section tKey="anonymousQuestions" t={t} />
<Section tKey="internationalDataTransfer" t={t} />

{/* 9. Your Rights (with subsections) */}
<Stack gap="xs">
<Text fz="1.5rem" ff="var(--ff-title)">
{t('legal.privacyPolicy.yourRights.title')}
</Text>
</Stack>
<SubSection tKey="yourRights.general" t={t} />
<SubSection tKey="yourRights.gdpr" t={t} />
<SubSection tKey="yourRights.kvkk" t={t} />

{/* 10-15: Simple sections */}
<Section tKey="dataSecurity" t={t} />
<Section tKey="childrenPrivacy" t={t} />
<Section tKey="doNotTrack" t={t} />
<Section tKey="changes" t={t} />
<Section tKey="dataController" t={t} />
<Section tKey="contact" t={t} />
</Stack>

<Stack mt="4rem" gap="md" justify="center" align="center">
<Image w="5rem" src="/assets/logo.svg" />
<Text
lh="1"
fz="2rem"
to={paths.home}
component={Link}
ff="var(--ff-title)"
>
whispi.io
</Text>
</Stack>
</Stack>
</Stack>
</Fragment>
);
}
